import { Controller } from "react-hook-form";
import { Input, Textarea, Autocomplete, AutocompleteItem } from "@heroui/react";

/**
 * InformasiUmumStep - Step 1: Basic product information
 */
const InformasiUmumStep = ({
    control,
    register,
    errors,
    categories,
    subCategories,
    isLoadingCategories,
    isLoadingSubCategories,
    categoryId,
}) => {
    return (
        <div className="flex flex-col gap-4">
            <Input
                {...register("name", {
                    required: "Nama produk wajib diisi",
                })}
                label="Nama Produk"
                placeholder="Contoh: Telur Ayam Merah 17kg"
                variant="bordered"
                isInvalid={!!errors.name}
                errorMessage={errors.name?.message}
                isRequired
            />
            <div
                className={`grid gap-4 ${
                    categoryId ? "grid-cols-2" : "grid-cols-1"
                }`}
            >
                <Controller
                    name="material_category_id"
                    control={control}
                    rules={{
                        required: "Kategori wajib dipilih",
                    }}
                    render={({ field }) => (
                        <Autocomplete
                            label="Kategori"
                            placeholder="Pilih kategori"
                            variant="bordered"
                            isLoading={isLoadingCategories}
                            defaultItems={categories || []}
                            selectedKey={
                                field.value ? String(field.value) : null
                            }
                            onSelectionChange={(key) => field.onChange(key)}
                            isInvalid={!!errors.material_category_id}
                            errorMessage={errors.material_category_id?.message}
                            isRequired
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={String(item.value)}
                                    textValue={item.title}
                                >
                                    {item.title}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    )}
                />
                {categoryId && (
                    <Controller
                        name="material_sub_category_id"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                label="Sub Kategori"
                                placeholder="Pilih sub kategori"
                                variant="bordered"
                                isLoading={isLoadingSubCategories}
                                defaultItems={subCategories || []}
                                selectedKey={
                                    field.value ? String(field.value) : null
                                }
                                onSelectionChange={(key) => field.onChange(key)}
                            >
                                {(item) => (
                                    <AutocompleteItem
                                        key={String(item.value)}
                                        textValue={item.title}
                                    >
                                        {item.title}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                        )}
                    />
                )}
            </div>
            <Textarea
                {...register("description")}
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang produk (opsional)"
                variant="bordered"
                minRows={3}
            />
        </div>
    );
};

export default InformasiUmumStep;
